import FormTemplate from "./FormTemplate.vue"
import InputBox from "./fields/InputBox.vue"
import TextArea from "./fields/RyomaTextArea.vue"
import RadioButton from "./fields/RyomaRadioButton.vue"
import CheckBox from "./fields/RyomaCheckBox.vue"

const COMPONENT_MAP = {
  formTemplate: FormTemplate,
  text: InputBox,
  textarea: TextArea,
  radio: RadioButton,
  check: CheckBox
}

export function getComponent(type) {
  return COMPONENT_MAP[type]
}